import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PlatformFooter from '../components/PlatformFooter';

function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="h-screen overflow-y-auto bg-gray-100 flex flex-col">
      <div className="text-center flex-1 flex flex-col items-center justify-center px-6 py-12">
        <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-600 mb-4">{t('Page Not Found')}</h2>
        <p className="text-gray-500 mb-6">
          {t("Page doesn't exist")}
        </p>
        <Link
          to="/dashboard"
          className="bg-primary-600 text-white px-6 py-3 rounded-lg hover:bg-primary-700 transition"
        >
          {t('Go to Dashboard')}
        </Link>
      </div>
      <PlatformFooter />
    </div>
  );
}

export default NotFound;
